<template>
  <div class="gzh-qrcode">
    <div class="gzh-qrcode__content" v-loading="loading">
      <template v-if="!isBind">
        <div class="gzh-qrcode__tips">扫码关注接收验证码</div>
        <el-image style="width: 100%; height: 100%" :src="qrCode">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="gzh-qrcode__refresh" v-if="isExpire">
          <div class="refresh_tips">二维码已过期</div>
          <el-button type="primary" icon="el-icon-refresh-right" @click="initQrcode">刷新</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="form" ref="form" :rules="rules" v-else>
        <el-form-item label="" prop="validateCode">
          <el-input v-model="form.validateCode" placeholder="请输入验证码"></el-input>
          <el-button type="default" @click="sendWeiXinCode" :disabled="isDisabled">{{verifyCodeInText}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
export default {
  name: 'yblQrcode',
  props: {
    customerId: { // 绑定人的 id
      type: String | Number,
      default: () => ''
    }
  },
  data () {
    return {
      loading: true,
      form: {
        validateCode: ''
      },
      rules: {
        validateCode: [{ required: true, message: '请输入验证码' }]
      },
      qrCode: '',
      yblopenId: '',
      qrcodeTimer: null, // 二维码定时器
      validateCodeTimer: null, // 验证码定时器
      verifyCodeInText: '获取验证码',
      isDisabled: false,
      verifyCode: null,
      isExpire: false // 二维码是否过期
    }
  },
  created () {
    this.$store = store
    this.initQrcode()
    this.$once('hook:beforeDestroy', () => {
      this.qrcodeTimer && clearInterval(this.qrcodeTimer)
      this.validateCodeTimer && clearInterval(this.validateCodeTimer)
    })
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER.data
    },
    isBind () { // 是否绑定
      return !!this.yblopenId
    }
  },
  methods: {
    initQrcode () {
      const _this = this
      let times = 0
      this.isExpire = false
      _this.queryOpenIdById().then(() => {
        if (!this.isBind) {
          _this.qrcodeTimer = setInterval(() => {
            if (times < 5) {
              _this.queryOpenIdById().then(() => {
                times++
              })
            } else {
              clearInterval(_this.qrcodeTimer)
              _this.qrcodeTimer = null
              _this.isExpire = true
            }
          }, 10000)
        }
      })
    },
    queryOpenIdById () {
      const params = {
        customerId: this.customerId || this.userInfo.CustomerId
      }
      return this.$store.dispatch('customerQueryOpenIdById', params).then(({ Dto }) => {
        // Dto 为 null 表示未开启 设置
        if (!Dto) {
          this.$emit('next', 'continue')

          return
        }
        if (!this.qrCode) {
          this.qrCode = Dto.qrCode
        }

        this.yblopenId = Dto.yblopenId
        if (this.yblopenId) {
          this.$emit('next', 'change', this.yblopenId)
        } else {
          this.$emit('scan', 'scan', this.yblopenId)
        }
        this.loading = false
      })
    },
    waitInputCode () {
      let verifyCode = 300
      this.isDisabled = true
      const _this = this
      this.validateCodeTimer = setInterval(() => {
        verifyCode > 0 && verifyCode--
        _this.verifyCodeInText = '重新获取(' + verifyCode + 's)'
        if (verifyCode === 0) {
          _this.verifyCodeInText = '获取验证码'
          _this.isDisabled = false
          _this.validateCodeTimer && clearInterval(_this.validateCodeTimer)
          _this.validateCodeTimer = null
        }
      }, 1000)
    },
    sendWeiXinCode () {
      const params = {
        customerId: this.customerId || this.userInfo.CustomerId
      }
      return this.$store.dispatch('customerSendWeiXinCode', params).then(() => {
        this.waitInputCode()
        this.$message({
          message: '验证码发送成功，请查收！',
          type: 'success'
        })
      })
    },
    submit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('next', this.form.validateCode, this.yblopenId)
        }
      })
    }

  }
}
</script>

<style lang="less">
.gzh-qrcode {
  max-width: 260px;
  .el-input {
    width: 130px;
    min-width: auto;
  }
  &__tips {
    text-align: left;
  }
  &__content {
    position: relative;
    text-align: left;
  }
  &__refresh {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    .refresh_tips {
      padding: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GzhQRCode.vue